import { getBusinessLines } from "@/modules/firestore_repo";

export const state = {
  allBusinessLinesList: [],
  isLoading: false
};

export const getters = {
  getAllBusinessLinesList: state => state.allBusinessLinesList
};

export const actions = {
  fetchBusinessLinesList: async ({ commit }) => {
    commit("setLoading", true);

    const data = await getBusinessLines();

    commit("setAllBusinessLinesList", data);
    commit("setLoading", false);
  }
};

export const mutations = {
  setAllBusinessLinesList: (state, payload) => {
    state.allBusinessLinesList = payload;
  },
  setLoading: (state, payload) => {
    state.isLoading = payload;
  }
};
